// extracted by mini-css-extract-plugin
export default {"people":"People_people__3KGUI","table":"People_table__ZVrs7","head":"People_head__sbA88"};